var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM11.6416 4.3584C11.3487 4.06572 10.8729 4.06558 10.5801 4.3584L7.99902 6.93848L5.41895 4.3584C5.12604 4.06573 4.65122 4.06559 4.3584 4.3584C4.06558 4.65122 4.06572 5.12603 4.3584 5.41895L6.93848 7.99902L4.3584 10.5801C4.06558 10.8729 4.06572 11.3487 4.3584 11.6416C4.65124 11.9342 5.12611 11.9342 5.41895 11.6416L7.99902 9.06055L10.5801 11.6416C10.873 11.9345 11.3487 11.9345 11.6416 11.6416C11.9345 11.3487 11.9345 10.873 11.6416 10.5801L9.06055 7.99902L11.6416 5.41895C11.9342 5.1261 11.9342 4.65123 11.6416 4.3584Z",
    fill: "#430A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.f53170ba9f9d74199ae71daa57d5f9e4.svg";
export { ForwardRef as ReactComponent };